export default "__VITE_ASSET__CiH$WgHv__"